import { Flex, Select, Text } from "@chakra-ui/react";
import { useEffect, useState } from "react";

interface SelectProps {
    label?: string;
    leftLabel?: string;
    topLabel?: string;
    width?: string;
    height?: string;
    gap?: string;
    array: { name: string; value: string | number; id: number }[];
    value?: string | number;
    onChange?: (value: string | number) => void;
    onEdit?: boolean;
}

export default function SelectComponent({
    width,
    height,
    array = [],
    gap,
    topLabel,
    leftLabel,
    value,
    onEdit,
    onChange,
}: SelectProps) {
    const [oldValue, setOldValue] = useState({});


    useEffect(() => {
        setOldValue(value)
    }, [value])

    return (
        <Flex justifyContent="center" alignItems="center" gap={gap || "8px"}>
            {leftLabel && <Flex>{leftLabel}</Flex>}
            <Flex flexDirection="column">
                {topLabel && (
                    <Text
                        color="rgba(138, 148, 168, 1)"
                        fontFamily="Hero New"
                        fontSize="12px"
                        lineHeight="16px"
                        marginLeft="6px"
                    >
                        {topLabel}
                    </Text>
                )}
                <Flex position="relative">
                    <Select
                        borderRadius="4px"
                        w={width || "111px"}
                        h={height || "29px"}
                        bgColor="rgba(237, 241, 247, 1)"
                        textAlign="left"
                        value={value || ""}
                        onChange={(e) => onChange?.(e.target.value)}
                        disabled={!onEdit}
                        color={value !== oldValue ? "rgba(212, 136, 6, 1)" : "black"}
                    >
                        {array.map((item) => (
                            <option
                                key={item.id}
                                value={item.value}
                            >
                                {item.name}
                            </option>
                        ))}
                    </Select>
                    {leftLabel && (
                        <Text position="absolute" left="6px" top="50%" transform="translateY(-50%)">
                            D +
                        </Text>
                    )}
                </Flex>
            </Flex>
        </Flex>
    );
}
